import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { VALIDATE } from '@/shared/constants/validation';

const validateSearch = z.object({
  email: VALIDATE.EMAIL,
  code: VALIDATE.OTP_CODE
});

export const Route = createFileRoute('/_auth/auth/forgot-password_/reset')({
  validateSearch
});
